/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcPlaidV1ProcessorTokenEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_PLAID_V1_PROCESSOR_TOKEN_EVENT_ENTITY_NAME = 'exc.plaid.v1.ProcessorTokenEvent';
export const excPlaidV1ProcessorTokenEventEntity = new schema.Entity<ExcPlaidV1ProcessorTokenEvent>(EXC_PLAID_V1_PROCESSOR_TOKEN_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcPlaidV1ProcessorTokenEvent) => `${entity.metadata?.eventId}` });

